import styled from "@emotion/styled";

import { ContentItemPlusOpinion } from "scmp-app/components/content/content-item-render/variants/plus-opinion";
import { ContentItemPlusPrimary } from "scmp-app/components/content/content-item-render/variants/plus-primary";
import { ContentItemPlusSecondary } from "scmp-app/components/content/content-item-render/variants/plus-secondary";

export const StyledContentItemPlusPrimary = styled(ContentItemPlusPrimary)``;

export const StyledContentItemPlusSecondary = styled(ContentItemPlusSecondary)``;

export const StyledContentItemPlusOpinion = styled(ContentItemPlusOpinion)``;
